import React from "react";
import PropTypes from "prop-types";

import SquareGrid from "icons/SquareGrid";
import SubmissionsDeniedItem from "./SubmissionsDeniedItem";

import { useViewport } from "js/hooks/useViewport";
import breakpoints from "core/breakpoints";

const DeniedGrid = ({ listData = [] }) => {
    const { browserWidth } = useViewport();
    const isMobile = browserWidth <= breakpoints.beforeTablet.px;
    const isTablet =
        browserWidth > breakpoints.beforeTablet.px &&
        browserWidth < breakpoints.desktop.px;

    let numberOfColumns = 5;

    if (isTablet) numberOfColumns = 3;
    if (isMobile) numberOfColumns = 2;

    const items = listData.map((data, index) => (
        <SubmissionsDeniedItem key={index} data={data} />
    ));

    return (
        <SquareGrid
            gridItemContent={items}
            numberOfColumns={numberOfColumns}
            gridSpacingSize={isMobile ? "1rem" : "1.5rem"}
        />
    );
};

DeniedGrid.propTypes = {
    listData: PropTypes.arrayOf(PropTypes.object)
};

export default DeniedGrid;
